import clsx from 'clsx';
import styles from './ActionDot.module.scss';

interface Props {
  className?: string;
}

export const ActionDot: React.FC<Props> = ({ className }) => <div className={clsx(styles.shape, className)} />;
